/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionspagetitle2Inputs */

const en_actionspagetitle2 = /** @type {(inputs: Actionspagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_actionspagetitle2 = /** @type {(inputs: Actionspagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Actionspagetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionspagetitle2 = /** @type {((inputs?: Actionspagetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionspagetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionspagetitle2(inputs)
	return de_actionspagetitle2(inputs)
});
export { actionspagetitle2 as "actionsPageTitle" }